import React from "react";
import { Outlet, NavLink, Link } from "react-router-dom";
import { KeyRound } from "lucide-react";

export default function PublicLayout() {
  return (
    <div className="public-root min-h-screen" data-testid="public-layout">
      <header className="public-header">
        <div className="public-container flex items-center justify-between py-6">
          <Link to="/" className="public-wordmark" data-testid="public-home-link">
            Elle Stuart
          </Link>
          <nav className="flex items-center gap-6 text-sm public-nav flex-wrap justify-end">
            <NavLink to="/" end className={({isActive}) => isActive ? "nav-active" : ""}>
              The Book
            </NavLink>
            <NavLink to="/excerpts" className={({isActive}) => isActive ? "nav-active" : ""}>
              Excerpts
            </NavLink>
            <NavLink to="/stories" className={({isActive}) => isActive ? "nav-active" : ""}>
              Stories
            </NavLink>
            <NavLink to="/essays" className={({isActive}) => isActive ? "nav-active" : ""}>
              Essays
            </NavLink>
            <NavLink to="/newsletter" className={({isActive}) => isActive ? "nav-active" : ""}>
              Newsletter
            </NavLink>
            <NavLink to="/about" className={({isActive}) => isActive ? "nav-active" : ""}>
              About
            </NavLink>
            <NavLink to="/contact" className={({isActive}) => isActive ? "nav-active" : ""}>
              Contact
            </NavLink>
            <Link to="/dashboard"
                  data-testid="public-shield-link"
                  title="Author sign-in (Shield)"
                  aria-label="Author sign-in"
                  className="public-nav-shield inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm"
                  style={{ border: "1px solid var(--warm-ink-faint)",
                           fontSize: "0.75rem",
                           letterSpacing: "0.1em",
                           textTransform: "uppercase" }}>
              <KeyRound size={13}/> Shield
            </Link>
          </nav>
        </div>
        <div className="public-rule"/>
      </header>

      <main className="public-container py-12 md:py-16">
        <Outlet />
      </main>

      <footer className="public-footer">
        <div className="public-rule mb-6"/>
        <div className="public-container flex flex-wrap items-center justify-between gap-4 pb-8 text-xs">
          <div>© {new Date().getFullYear()} Elle Stuart. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/newsletter">Newsletter</Link>
            <a href="https://bsky.app/profile/bigboggin.bsky.social" target="_blank" rel="noreferrer">
              Bluesky
            </a>
            <Link to="/contact">Contact</Link>
            <span style={{ color: "var(--warm-ink-faint)" }}>·</span>
            <Link to="/dashboard" data-testid="public-shield-link"
                  title="Author sign-in"
                  aria-label="Author sign-in"
                  style={{ color: "var(--warm-ink-faint)",
                           letterSpacing: "0.08em",
                           fontSize: "0.75rem",
                           textTransform: "uppercase" }}>
              Shield
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
